// Export the Component Definition for use in Contentful Studio
export {RichTextContentfulComponentDefinition} from './RichTextContentfulDefinition';
export {default} from './RichText';
